import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility/utility";
import { InfoToast, SuccessToast } from "../../hoc/ToastNotify/ToastNotify";

const initialState = {
  name: null,
  user_id: null,
  cellphone: null,
  errors: null,
  loading: false,
  success: false,
};

const registerStart = (state, action) => {
  return updateObject(state, {
    errors: null,
    loading: true,
    success: false,
  });
};

const registerSuccess = (state, action) => {
  SuccessToast(
    "ثبت نام با موفقیت انجام و کد تایید به شماره همراه شمار ارسال گردید.",
  );
  InfoToast("به صفحه تایید شماره همراه منتقل می شوید.");
  return updateObject(state, {
    name: action.name,
    cellphone: action.cellphone,
    user_id: action.user_id,
    errors: null,
    loading: false,
    success: true,
  });
};
const registerFail = (state, action) => {
  return updateObject(state, {
    success: false,
    errors: action.errors,
    loading: false,
    name: null,
    user_id: null,
    cellphone: null,
  });
};

const registerLoad = (state, action) => {
  return updateObject(state, { errors: null, errorsJson: null });
};

const registerClear = (state, action) => {
  return updateObject(state, {
    name: null,
    user_id: null,
    cellphone: null,
    errors: null,
    loading: false,
    success: false,
  });
};

const registerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REGISTER_START:
      return registerStart(state, action);
    case actionTypes.REGISTER_SUCCESS:
      return registerSuccess(state, action);
    case actionTypes.REGISTER_FAIL:
      return registerFail(state, action);
    case actionTypes.REGISTER_LOAD:
      return registerLoad(state, action);
    case actionTypes.REGISTER_CLEAR:
      return registerClear(state, action);
    default:
      return state;
  }
};

export default registerReducer;
